import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';

import TotalModalWrapper from '../../../Model/Share/Normal/TotalModalWrapper';
import SearchInput from './SearchInput';
import SelectStatusBox from './SelectStatusBox';
import SelectGenderBox from './SelectGenderBox';
import SelectAbsenceBox from './SelectAbsenceBox';
import SelectRemainDayBox from './SelectRemainDayBox';
import SortingModule from '../../../Model/Share/Normal/SortingModule';
import UserProfile from '../../../Component/Normal/UserProfile';

import NormalSortButtonPath from '../../../image/GrayNormalSortButton.png';
import AscSortButtonPath from '../../../image/AscSortButton.png';
import DescSortButtonPath from '../../../image/DescSortButton.png';
import DefaultProfile from '../../../image/DefaultProfile.png';
import { ReactComponent as CheckSvg } from '../../../image/Check2.svg';

export default function SendMemberSelectModal(props) {
  const { memberList, onClickAdditionButton, onClickExit } = props;

  const { t, languageMode } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [members, setMembers] = useState([]);
  const [originalSortedMembers, setOriginalSortedMembers] = useState([]);
  const [sortedMembers, setSortedMembers] = useState([]);
  const [notPaginationSortedMembers, setNotPaginationSortedMembers] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const [isClickedValidSorting, setIsClickedValidSorting] = useState(true);
  const [isClickedInvalidSorting, setIsClickedInvalidSorting] = useState(false);

  const [isClickedMaleSorting, setIsClickedMaleSorting] = useState(false);
  const [isClickedFemaleSorting, setIsClickedFemaleSorting] = useState(false);

  const [absenceStart, setAbsenceStart] = useState(0);
  const [absenceEnd, setAbsenceEnd] = useState(0);

  const [remainDayStart, setRemainDayStart] = useState(0);
  const [remainDayEnd, setRemainDayEnd] = useState(0);

  const [startSort, setStartSort] = useState('normal');
  const [endSort, setEndSort] = useState('desc');

  const [startButtonImg, setStartButtonImg] = useState(AscSortButtonPath);
  const [endButtonImg, setEndButtonImg] = useState(AscSortButtonPath);

  const [isClickedAllMemberSelect, setIsClickedAllMemberSelect] = useState(false);
  const [nowPage, setNowPage] = useState(0);
  const [totalPage, setTotalPage] = useState(1);

  // 회원 선택 체크 변수 처리 //
  useEffect(() => {
    let newMembers = memberList.slice();
    let count = 0;
    newMembers.map((data) => {
      if (data.isClicked) count += 1;
    });

    if (count === newMembers.length) setIsClickedAllMemberSelect(true);
    else setIsClickedAllMemberSelect(false);

    newMembers = SortingModule.dataSort(newMembers, 'endDate', 'desc', 'endDate');

    setMembers(newMembers);
    setOriginalSortedMembers(newMembers);
  }, [memberList])

  // 회원정보 정렬 //
  useEffect(() => {
    if (members.length === 0) setSortedMembers([]);
    else {
      let newMembers = [];

      // 유효, 만료 회원 추출 데이터 //
      let validCheckMembers = [];

      // 유효회원 둘다 체크되어있거나 둘다 체크하지 않은 경우 //
      if ((isClickedValidSorting && isClickedInvalidSorting)
        || (!isClickedValidSorting && !isClickedInvalidSorting)) {
          validCheckMembers = members;
      }
      // 유효회원만 체크되어있는 경우 //
      else if (isClickedValidSorting) {
        members.map((data) => {
          if (moment().isBefore(moment(data.endDate))
            && (data.totalMax === -1 || data.totalMax > data.reserveCount)) {
              validCheckMembers.push(data);
          }
        })
      }
      // 만료회원만 체크되어있는 경우 //
      else if (isClickedInvalidSorting) {
        members.map((data) => {
          if (moment().isAfter(moment(data.endDate))
            || (data.totalMax <= data.reserveCount && data.totalMax !== -1)) {
              validCheckMembers.push(data);
          }
        })
      }

      // 성별구분 추출 데이터 //
      let genderCheckMembers = [];
      
      // 성별 둘다 체크되어있거나 둘다 체크하지 않은 경우//
      if ((isClickedFemaleSorting && isClickedMaleSorting)
        || (!isClickedFemaleSorting && !isClickedMaleSorting)) {
        genderCheckMembers = validCheckMembers;
      }
      // 여성만 체크된 경우 //
      else if (isClickedFemaleSorting) {
        validCheckMembers.map((data) => {
          if (data.gender === 'female') genderCheckMembers.push(data);
        })
      }
      // 남성만 체크된 경우 //
      else if (isClickedMaleSorting) {
        validCheckMembers.map((data) => {
          if (data.gender === 'male') genderCheckMembers.push(data);
        })
      }

      // 미출석 기간 추출 데이터 //
      let absenceCheckMembers = [];

      // 미출석 기간설정이 활성화 되지 않은 경우 //
      if (absenceStart === 0 && absenceEnd === 0) {
        absenceCheckMembers = genderCheckMembers;
      }
      // 활성화 되어있는경우 //
      else {
        genderCheckMembers.map((data) => {
          if (data.reserves.length > 0) {
            let classDate = moment(data.reserves[data.reserves.length - 1].classDate);

            if (moment().diff(classDate, 'days') >= absenceStart
            && moment().diff(classDate, 'days') <= absenceEnd) {
              absenceCheckMembers.push(data);
            }
          }
        })
      }

      // 잔여 일수 추출 데이터 //
      let remainDayMembers = [];

      // 미출석 기간설정이 활성화 되지 않은 경우 //
      if (remainDayStart === 0 && remainDayEnd === 0) {
        remainDayMembers = absenceCheckMembers;
      }
      // 활성화 되어있는경우 //
      else {
        absenceCheckMembers.map((data) => {
          let endDate = moment(data.endDate);

          if (moment().diff(endDate, 'days') >= remainDayStart
          && moment().diff(endDate, 'days') <= remainDayEnd) {
            remainDayMembers.push(data);
          }
        })
      }

      if (startSort === 'asc') remainDayMembers = SortingModule.dataSort(remainDayMembers, 'startDate', 'asc', 'startDate');
      else if (startSort === 'desc') remainDayMembers = SortingModule.dataSort(remainDayMembers, 'startDate', 'desc', 'startDate');
      else if (endSort === 'asc') remainDayMembers = SortingModule.dataSort(remainDayMembers, 'endDate', 'asc', 'endDate');
      else if (endSort === 'desc') remainDayMembers = SortingModule.dataSort(remainDayMembers, 'endDate', 'desc', 'endDate');

      let nameList = [];
      let phoneList = [];
  
      for (let i = 0; i < remainDayMembers.length; i++) {
        if (remainDayMembers[i].name.toLowerCase().includes(searchValue.toLowerCase())) nameList.push(remainDayMembers[i]);
        else if (remainDayMembers[i].phone.includes(searchValue)) phoneList.push(remainDayMembers[i]);
      }
  
      if (nameList.length === 0 && phoneList.length === 0) {
        for (let i = 0; i < remainDayMembers.length; i++) {
          if (match(searchValue.toLowerCase(), remainDayMembers[i].name.toLowerCase())) nameList.push(remainDayMembers[i]);
        }
      }
  
      let totalList = nameList.concat(phoneList);
      
      if (totalList.length > 10) {
        let finalPage = parseInt(totalList.length / 10);

        if (nowPage > finalPage) setNowPage(finalPage);
        
        setTotalPage(finalPage + 1);
      }
      else {
        setNowPage(0);
        setTotalPage(1);
      }

      // 페이지 분리 //
      if (totalList.length !== 0) {
        if (totalList.length > 10) newMembers = totalList.slice((nowPage * 10), (nowPage * 10) + 10);
        else newMembers = totalList.slice();
      }
  
      setSortedMembers(newMembers);
      setNotPaginationSortedMembers(totalList);
      setIsClickedAllMemberSelect(false);
    }
  }, 
  [
    members,
    searchValue, 
    isClickedValidSorting, 
    isClickedInvalidSorting,
    isClickedMaleSorting,
    isClickedFemaleSorting,
    absenceStart,
    absenceEnd,
    remainDayStart,
    remainDayEnd,
    startSort,
    endSort,
    nowPage,
    match()
  ])

  // 시작일 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (startSort === 'normal') setStartButtonImg(NormalSortButtonPath);
    else if (startSort === 'asc') setStartButtonImg(AscSortButtonPath);
    else if (startSort === 'desc') setStartButtonImg(DescSortButtonPath);
  }, [startSort])

  // 종료일 버튼 클릭시 이미지 변경 //
  useEffect(() => {
    if (endSort === 'normal') setEndButtonImg(NormalSortButtonPath);
    else if (endSort === 'asc') setEndButtonImg(AscSortButtonPath);
    else if (endSort === 'desc') setEndButtonImg(DescSortButtonPath);
  }, [endSort])

  // 몇명 선택되었는지 텍스트 표출 //
  function decideSelectedCountText() {
    let count = 0;

    originalSortedMembers.map((data) => {
      if (data.isClicked) count += 1;
    })

    return count + ' ' + t('messageSend.memberSelect.personUnit');
  }

  // 입력된 글자가 한글인지 확인 //
  function is_kr(value) {
    if (value === undefined) return false;
    
    return ((('ㄱ'.charCodeAt() <= value.charCodeAt()) && (value.charCodeAt() <= 'ㅎ'.charCodeAt()))
            || (('가'.charCodeAt() <= value.charCodeAt()) && value.charCodeAt() <= '힣'.charCodeAt()));
  }

  // 한글 글자 유니코드 추출하여 검색 조건 확인 //
  function kr_num(value) {
    return value.charCodeAt() - '가'.charCodeAt();
  }

  // 초성 중성 종성 구분하여 연산 //
  function kr_list(value) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                        , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    const res = [value];

    const kr_num_s = kr_num(value);

    if (kr_num_s > 0) {
      // 초성 + 중성일 경우 //
      if (kr_num_s % 28 !== 0) {
        res.push(String.fromCharCode(((parseInt(kr_num_s / 28) * 28) + '가'.charCodeAt())));
      }
      
      res.push(consonant_list[parseInt(kr_num_s / 588)])
    }

    return res;
  }

  // 한글, 영어 구분하여 검색 처리 //
  function eq_kr(value, data) {
    if (is_kr(value) && is_kr(data)) {
      return kr_list(data).includes(value);
    }
    else return value === data;
  }

  // 받침 확인하기 //
  function eq_kr_pos(value, data, nextData) {
    const consonant_list = ['ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ'
                        , 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];

    const kr_pos = [
      [0, 0], [1, 0], [2, 1], [2, 9], [4, 2], [1, 12], [2, 18],
      [7, 3], [8, 5], [1, 0], [2, 6], [3, 7], [4, 9], [5, 16],
      [6, 17], [7, 18], [16, 6], [17, 7], [1, 9], [19, 9], [20, 10],
      [21, 11], [22, 12], [23, 14], [24, 15], [25, 16], [26, 17], [27, 18]
    ]

    if (!(is_kr(value) && is_kr(data) && is_kr(nextData))) return false;
    if (kr_num(value) < 0) return false;
    
    const s_pos = String.fromCharCode(value.charCodeAt() - kr_pos[kr_num(value) % 28][0])
    const s_pos_consonant = consonant_list[kr_pos[kr_num(value) % 28][1]]

    return (s_pos === data) && (kr_list(nextData).includes(s_pos_consonant));
  }

  // 일치하는 글자가 존재하는지 확인 //
  function match(value, data) {
    if (value === undefined || data === undefined) return false;

    const valueSize = value.length;
    const dataSize = data.length;

    if (dataSize < valueSize) return false;

    for (let i = 0; i < (dataSize - valueSize + 1); i++) {
      let res = true;

      for (let j = 0; j < valueSize; j++) {
        if (j === (valueSize - 1)) {
          if (!eq_kr(value[j], data[i + j])) {
            if (i + j + 1 < dataSize) {
              if (eq_kr_pos(value[j], data[i + j], data[i + j + 1])) {
                break;
              }
            }
            res = false;
            break;
          }
        }
        else {
          if (value[j] !== data[i + j]) {
            res = false;
            break;
          }
        }
      }

      if (res) return true;
    }
    
    return false;
  }

  // 필터 초기화 클릭시 //
  function onClickResetFilter() {

    let newOriginalSortedMembers = originalSortedMembers.slice();

    newOriginalSortedMembers.map((data) => data.isClicked = false);

    setOriginalSortedMembers(newOriginalSortedMembers);
    setNotPaginationSortedMembers(newOriginalSortedMembers);

    setSearchValue('');
    setIsClickedValidSorting(false);
    setIsClickedInvalidSorting(false);
    setIsClickedMaleSorting(false);
    setIsClickedFemaleSorting(false);
    setIsClickedAllMemberSelect(false);
    setAbsenceStart(0);
    setAbsenceEnd(0);
    setRemainDayStart(0);
    setRemainDayEnd(0);
    setStartSort('normal');
    setEndSort('desc');
  }

  // 시작일 정렬 버튼 클릭시 //
  function onClickStartSort() {
    setEndSort('normal');

    if (startSort === 'normal' || startSort === 'desc') setStartSort('asc');
    else if (startSort === 'asc') setStartSort('desc');
  }

  // 종료일 정렬 버튼 클릭시 //
  function onClickEndSort() {
    setStartSort('normal');

    if (endSort === 'normal' || endSort === 'desc') setEndSort('asc');
    else if (endSort === 'asc') setEndSort('desc');
  }

  // 전체선택 클릭시 //
  function onClickAllSelectButton() {
    let newNotPaginationSortedMembers = notPaginationSortedMembers.slice();

    newNotPaginationSortedMembers.map((data) => data.isClicked = !isClickedAllMemberSelect);

    setNotPaginationSortedMembers(newNotPaginationSortedMembers);
    setIsClickedAllMemberSelect(!isClickedAllMemberSelect);
  }

  // 페이지네이션 이전버튼 클릭시 //
  function onClickPrevButton() {
    if (nowPage !== 0) {
      setNowPage(nowPage - 1);
    }
  }

  // 페이지네이션 다음버튼 클릭시 //
  function onClickNextButton() {
    if ((nowPage + 1) !== totalPage) {
      setNowPage(nowPage + 1);
    }
  }

  // 회원 선택시 //
  function onClickMemberInfo(data) {
    let newOriginalSortedMembers = originalSortedMembers.slice();
    let index = newOriginalSortedMembers.findIndex(item => item.memberId === data.memberId);

    if (newOriginalSortedMembers[index].isClicked) setIsClickedAllMemberSelect(false);

    newOriginalSortedMembers[index].isClicked = !newOriginalSortedMembers[index].isClicked;

    setOriginalSortedMembers(newOriginalSortedMembers);
  }

  // 회원 선택목록에서 제외버튼 클릭시 //
  function onClickDeleteButton(data) {
    let newOriginalSortedMembers = originalSortedMembers.slice();
    let index = newOriginalSortedMembers.findIndex(item => item.memberId === data.memberId);

    if (newOriginalSortedMembers[index].isClicked) setIsClickedAllMemberSelect(false);

    newOriginalSortedMembers[index].isClicked = !newOriginalSortedMembers[index].isClicked;

    setOriginalSortedMembers(newOriginalSortedMembers);
  }

  // 회원 추가하기 버튼 클릭시 //
  function onClickAddition() {
    let members = originalSortedMembers.slice();
    let selectedMembers = [];

    members.map((data) => {
      if (data.isClicked) selectedMembers.push(data);
    })

    onClickAdditionButton(selectedMembers);
  }

  return (
    <TotalModalWrapper>
      <Modal isDark={isDark}>
        <ModalInnerWrapper>
          <TopLineWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} hover='default'>{t('messageSend.memberSelect.title')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='default'>{t('messageSend.memberSelect.description')}</Text>
            </TitleWrapper>
            <ButtonWrapper>
              <ExitButton onClick={onClickExit}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.memberSelect.cancel')}</Text>
              </ExitButton>
              <AdditionButton onClick={onClickAddition}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} hover='pointer'>{t('messageSend.memberSelect.add')}</Text>
              </AdditionButton>
            </ButtonWrapper>
          </TopLineWrapper>
          <SearchInputWrapper>
            <SearchInput value={searchValue} setValue={setSearchValue} placeholder={t('messageSend.memberSelect.searchPlaceholder')} width={495} />
          </SearchInputWrapper>
          <ResetAndSortingButtonWrapper>
            <SortingButtonWrapper>
              <SelectStatusBox
                isClickedValidSorting={isClickedValidSorting}
                isClickedInvalidSorting={isClickedInvalidSorting}
                setIsClickedValidSorting={setIsClickedValidSorting}
                setIsClickedInvalidSorting={setIsClickedInvalidSorting} />

              <SelectGenderBox
                isClickedMaleSorting={isClickedMaleSorting}
                isClickedFemaleSorting={isClickedFemaleSorting}
                setIsClickedMaleSorting={setIsClickedMaleSorting}
                setIsClickedFemaleSorting={setIsClickedFemaleSorting} />

              <SelectAbsenceBox
                absenceStart={absenceStart}
                absenceEnd={absenceEnd}
                setAbsenceStart={setAbsenceStart}
                setAbsenceEnd={setAbsenceEnd} />

              <SelectRemainDayBox
                remainDayStart={remainDayStart}
                remainDayEnd={remainDayEnd}
                setRemainDayStart={setRemainDayStart}
                setRemainDayEnd={setRemainDayEnd} />

            </SortingButtonWrapper>
            <FilterResetButton onClick={onClickResetFilter}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} hover='pointer'>{t('messageSend.memberSelect.resetFilter')}</Text>
            </FilterResetButton>
          </ResetAndSortingButtonWrapper>

          <TotalMemberBoxWrapper>
            <TotalMemberBox>
              <TotalMemberColumnWrppaer>
                <MemberCheckBox isClicked={isClickedAllMemberSelect} onClick={onClickAllSelectButton}>
                  { isClickedAllMemberSelect && <CheckIcon /> }
                </MemberCheckBox>
                <TextWrapper marginLeft={12} width={60}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.name')}</Text>
                </TextWrapper>
                <TextWrapper marginLeft={4} width={50}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.gender')}</Text>
                </TextWrapper>
                <TextWrapper marginLeft={4} width={85}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.birthDate')}</Text>
                </TextWrapper>
                <TextWrapper marginLeft={4} width={94}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.phone')}</Text>
                </TextWrapper>
                <TextWrapper marginLeft={4} width={191}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.membership')}</Text>
                </TextWrapper>
                <TextWrapper marginLeft={4} width={100}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.startDate')}</Text>
                  <SortingButton img={startButtonImg} onClick={() => onClickStartSort()} />
                </TextWrapper>
                <TextWrapper marginLeft={4} width={100}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} hover='default'>{t('messageSend.memberSelect.endDate')}</Text>
                  <SortingButton img={endButtonImg} onClick={() => onClickEndSort()} />
                </TextWrapper>
              </TotalMemberColumnWrppaer>
              <TotalMemberListWrapper>
                {
                  sortedMembers.map((data, index) => (
                    <TotalMemberInfo key={'TotalSendMember-' + index} isDark={isDark} onClick={() => onClickMemberInfo(data)}>
                      <MemberCheckBox isClicked={data.isClicked}>
                        { data.isClicked && <CheckIcon /> }
                      </MemberCheckBox>
                      <TextWrapper marginLeft={12} width={60}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.name}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={50}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.gender === 'male' ? t('messageSend.memberSelect.male') : t('messageSend.memberSelect.female')}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={85}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{moment(data.birth, 'YYYYMMDD').format(t('noticePage.dateFormatShort'))}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={94}>
                        <Text style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('messageSend.memberSelect.none')}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={191}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{data.membershipName}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={100}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{moment(data.startDate).format(t('noticePage.dateFormatShort'))}</Text>
                      </TextWrapper>
                      <TextWrapper marginLeft={4} width={100}>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{moment(data.endDate).format(t('noticePage.dateFormatShort'))}</Text>
                      </TextWrapper>
                      {
                        (moment(data.endDate).diff(moment(), 'day') >= 0 && moment(data.endDate).diff(moment(), 'day') <= 5) &&
                        <TextWrapper marginLeft={4} width={45}>
                          <Dday>{moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') === 0 ? 'D-day' : 'D-' + moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day')}</Dday>
                        </TextWrapper>
                      }
                    </TotalMemberInfo>
                  ))
                }
              </TotalMemberListWrapper>
              <PaginationTotalWrapper>
                <PaginationWrapper>
                  <Text onClick={onClickPrevButton} fontFamily='NotoSansKR-Regular' fontSize={14} color={nowPage === 0 ? theme.line : theme.text} hover='pointer'>{t('messageSend.memberSelect.prev')}</Text>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='default'>{(nowPage + 1) + '/' + totalPage}</Text>
                  <Text onClick={onClickNextButton} fontFamily='NotoSansKR-Regular' fontSize={14} color={(nowPage + 1) === totalPage ? theme.line : theme.text} hover='pointer'>{t('messageSend.memberSelect.next')}</Text>
                </PaginationWrapper>
              </PaginationTotalWrapper>
            </TotalMemberBox>
            <SelectedMemberBoxWrapper>
              <SelectedTextWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.subText} hover='default'>{t('messageSend.memberSelect.currentlyPrefix')}</Text>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.primary} hover='default'>{decideSelectedCountText()}</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.subText} hover='default'>{t('messageSend.memberSelect.currentlySuffix')}</Text>
              </SelectedTextWrapper>
              <DivisionLine/>
              <SelectedMemberBox>
                <SelectedMemberInfoWrapper>
                  {
                    originalSortedMembers.map((data, index) => (
                      data.isClicked &&
                      <SelectedMemberInfo key={'SelectedSortMember-' + index}>
                        <ProfileWrapper isFirst={index === 0} isLast={originalSortedMembers.length - 1 === index}>
                          <UserProfile profile={data.profile} defaultProfile={DefaultProfile} />
                        </ProfileWrapper>
                        <TextWrapper marginLeft={10} width={45}>
                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{data.name}</Text>
                        </TextWrapper>
                        <TextWrapper marginLeft={4} width={98}>
                          <Text style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText} hover='default'>{formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('messageSend.memberSelect.none')}</Text>
                        </TextWrapper>
                        <DeleteButtonWrapper onClick={() => onClickDeleteButton(data)}>
                          <DeleteButton>
                            <Stick width={10} height={2} radius={0} backgroundColor={theme.line}/>
                            <Stick width={2} height={10} radius={0} backgroundColor={theme.line}/>
                          </DeleteButton>
                        </DeleteButtonWrapper>
                      </SelectedMemberInfo>
                    ))
                  }
                </SelectedMemberInfoWrapper>
              </SelectedMemberBox>
            </SelectedMemberBoxWrapper>
          </TotalMemberBoxWrapper>
        </ModalInnerWrapper>
      </Modal>
    </TotalModalWrapper>
  )
}

const Modal = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1053px;
  height: 662px;

  border-radius: 15px;
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.background};
`;

const ModalInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: calc(100% - 40px);
  height: 626px;
`;

const TopLineWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const AdditionButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SearchInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
`;

const ResetAndSortingButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin-top: 12px;

  width: 100%;
`;

const SortingButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const FilterResetButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 83px;
  height: 20px;

  border: 1px solid ${props => props.theme.buttonStroke};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalMemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 20px;

  width: 1013px;
  height: 473px;
`;

const TotalMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 752px;
  height: 430px;
`;

const TotalMemberColumnWrppaer = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 6px;

  width: calc(100% - 12px);
`;

const MemberCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: ${props => props.marginLeft}px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const SortingButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  margin-left: 4px;

  width: 20px;
  height: 20px;

  background: url(${props => props.img}) no-repeat center center;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalMemberListWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 15px;

  width: 100%;
  min-height: 395px;
  max-height: 395px;

  gap: 5px;
`;

const TotalMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 6px;

  width: calc(100% - 12px);
  height: 35px;

  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PaginationTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 16px;

  width: 100%;
`;

const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 12px;
`;

const SelectedMemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 241px;
  height: 378px;
`;

const SelectedTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const SelectedMemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 241px;
  height: 333px;

  border-radius: 10px;
  overflow-x: hidden;
  overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.buttonStroke};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const SelectedMemberInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 234px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;
`;

const SelectedMemberInfo = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 37px;
`;

const ProfileWrapper = styled.div`
  position: relative;
  width: 44px;
  height: 44px;

  // border-top-left-radius: ${props => props.isFirst ? `4px` : `0px`};
  // border-bottom-left-radius: ${props => props.isLast ? `4px` : `0px`};

  overflow: hidden;

  img {
    object-fit: cover;
  }
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  margin: 10px 0px;

  width: 194px;
  height: 1px;

  border-radius: 2px;
  background-color: ${props => props.theme.line};
`;

const Dday = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 20px;

  border-radius: 30px;
  background-color: ${props => props.theme.primary};

  font-family: NotoSansKR-Regular;
  font-size: 11px;

  color: ${props => props.theme.white};

  margin: 0 0 0 0;
`;

const DeleteButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-left: 10px;

  width: 23px;
  height: 23px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DeleteButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  transform: rotate(45deg);
`;

const Stick = styled.div`
  position: absolute;
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: ${props => props.backgroundColor};
`;

const CheckIcon = styled(CheckSvg)`
  width: 10px;
  height: auto;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;